/* Moonlight Feather - wedding collection enhancements (Dawn 15)
 * 1. Splits "10 Pieces - Natural White ..." product titles into a small pack-size line + name.
 * 2. Replaces numbered pagination with a "Load more" button (numbered links stay in the page
 *    for SEO and are restored automatically if anything goes wrong).
 * Only runs inside the section keyed "mlf-grid". Safe to load more than once.
 */
(function () {
  if (window.__mlfWedding) return;
  window.__mlfWedding = true;

  var STR = {
    showing: 'Showing {loaded} of {total}',
    showingNoTotal: 'Showing {loaded}',
    all: 'All {total} products shown',
    load: 'Load more',
    loading: 'Loading…'
  };
  var PACK_RE = /^(\d+(?:\.\d+)?\s+[A-Za-z][A-Za-z .]{1,22}?)\s+[-–—]\s+(.+)$/;

  function fmt(s, o) {
    return s.replace(/\{(\w+)\}/g, function (_, k) { return o[k]; });
  }

  function section() {
    return document.querySelector('[id$="__mlf-grid"]');
  }

  /* 1. pack size / name split ------------------------------------------------ */
  function splitTitles(root) {
    var links = root.querySelectorAll('.card__heading a.full-unstyled-link');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-mlf-split')) continue;
      a.setAttribute('data-mlf-split', '1');
      var text = a.textContent.replace(/\s+/g, ' ').trim();
      var m = PACK_RE.exec(text);
      if (!m) continue;
      var pack = document.createElement('span');
      pack.className = 'mlf-pack';
      pack.textContent = m[1];
      var name = document.createElement('span');
      name.className = 'mlf-name';
      name.textContent = m[2];
      a.textContent = '';
      a.appendChild(pack);
      a.appendChild(document.createTextNode(' '));
      a.appendChild(name);
    }
  }

  /* 2. load more -------------------------------------------------------------- */
  function pageNumber(el) {
    var n = parseInt((el.textContent || '').replace(/\D/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function totalProducts() {
    var el = document.getElementById('ProductCount');
    if (!el) return 0;
    var m = (el.textContent || '').replace(/,/g, '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  function setupLoadMore(sec) {
    var grid = sec.querySelector('#product-grid');
    var pagination = sec.querySelector('.pagination-wrapper');
    var old = sec.querySelector('.mlf-loadmore');
    if (old) old.remove();
    sec.classList.remove('mlf-loadmore-on');
    if (!grid || !pagination) return;

    var currentEl = pagination.querySelector('.pagination__item--current');
    var current = currentEl ? pageNumber(currentEl) : 1;
    var last = current;
    var items = pagination.querySelectorAll('.pagination__item');
    for (var i = 0; i < items.length; i++) {
      last = Math.max(last, pageNumber(items[i]));
    }
    if (last <= current) return;

    var total = totalProducts();
    var next = current + 1;

    var wrap = document.createElement('div');
    wrap.className = 'mlf-loadmore';
    wrap.innerHTML =
      '<p class="mlf-loadmore__count" role="status" aria-live="polite"></p>' +
      '<div class="mlf-loadmore__bar" aria-hidden="true"><span></span></div>' +
      '<button type="button" class="mlf-btn mlf-btn--ghost"></button>';
    pagination.parentNode.insertBefore(wrap, pagination.nextSibling);
    var countEl = wrap.querySelector('.mlf-loadmore__count');
    var barEl = wrap.querySelector('.mlf-loadmore__bar > span');
    var btn = wrap.querySelector('button');
    btn.textContent = STR.load;
    sec.classList.add('mlf-loadmore-on');

    function loaded() {
      return grid.querySelectorAll(':scope > li').length;
    }

    function render() {
      var n = loaded();
      countEl.textContent = total
        ? fmt(STR.showing, { loaded: n, total: total })
        : fmt(STR.showingNoTotal, { loaded: n });
      var pct = total ? Math.max(1.5, Math.min(100, (n / total) * 100)) : 100;
      barEl.style.width = pct + '%';
      if (next > last) {
        btn.hidden = true;
        if (total) countEl.textContent = fmt(STR.all, { total: total });
      }
    }

    function fail() {
      wrap.remove();
      sec.classList.remove('mlf-loadmore-on');
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = STR.loading;
      var url = new URL(window.location.href);
      url.searchParams.set('page', String(next));
      url.hash = '';
      fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('bad response');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.querySelectorAll('#product-grid > li');
          if (!incoming.length) throw new Error('no products');
          for (var i = 0; i < incoming.length; i++) {
            grid.appendChild(document.importNode(incoming[i], true));
          }
          next += 1;
          splitTitles(grid);
          if (typeof window.initializeScrollAnimationTrigger === 'function') {
            try { window.initializeScrollAnimationTrigger(grid); } catch (e) { /* ignore */ }
          }
          btn.disabled = false;
          btn.textContent = STR.load;
          render();
        })
        .catch(fail);
    });

    render();
  }

  /* wiring -------------------------------------------------------------------- */
  var busy = false;
  function enhance() {
    var sec = section();
    if (!sec || busy) return;
    busy = true;
    try {
      splitTitles(sec);
      if (!sec.querySelector('.mlf-loadmore') && !sec.classList.contains('mlf-loadmore-on')) {
        setupLoadMore(sec);
      }
    } finally {
      busy = false;
    }
  }

  function start() {
    var sec = section();
    if (!sec) return;
    enhance();
    var container = sec.querySelector('#ProductGridContainer') || sec;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        var s = section();
        if (!s) return;
        splitTitles(s);
        // Dawn replaced the grid (filter / sort): rebuild the button for the new results.
        if (!s.querySelector('.mlf-loadmore') && s.querySelector('.pagination-wrapper')) {
          s.classList.remove('mlf-loadmore-on');
          setupLoadMore(s);
        }
      });
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Theme editor: re-run when sections are added or reloaded.
  document.addEventListener('shopify:section:load', function () {
    window.__mlfWedding = true;
    enhance();
  });
})();
